import server from "../core/Server.ts";
import type {CustomerData} from "../core/CustomerData.ts";
import {Input, Label, SuggestionItem} from "@ui5/webcomponents-react";
import {useEffect, useState} from "react";

let timeout: number = 0;

interface CustomerFilterProps {
    disabled?: boolean;
    onSelect: (customer: CustomerData|undefined) => void;
}


export function CustomerFilter(props: CustomerFilterProps) {

    const [customerData, setCustomerData] = useState<CustomerData[]>([]);
    const [isLoading, setIsLoading] = useState<true | undefined>();
    const [value, setValue] = useState('');
    const [skipFetch, setSkipFetch] = useState(false);


    useEffect(() => {
        if (skipFetch) {
            setSkipFetch(false);
            return;
        }
        if (timeout > 0) {
            clearTimeout(timeout);
        }
        const fetchData = async () => {
            setIsLoading(true);
            if (value.length < 2) {
                setCustomerData([]);
                setIsLoading(undefined);
                return;
            }
            const customers = await server.getCustomerList(value);

            if (customers.length === 1) {
                props.onSelect(customers[0]);
                setSkipFetch(true);
                setValue(customers[0].name);
                setCustomerData([]);
            } else {
                setCustomerData(customers);
            }
            setIsLoading(undefined);
        };
        timeout = setTimeout(fetchData, 250);
    }, [value]);


    return <div className="sc_filter">
        <Label className="sc_label">Customer</Label>
        <Input
            className="sc_input"
            disabled={props.disabled}
            icon={null}
            key={'customer'}
            onInput={ev => {
                props.onSelect(undefined);
                const val = ev.target.value;
                setValue(val);
            }
            }
            onClose={ev => {
                setValue(ev.target.value);
            }}
            onSelect={ev => {
                const customer = customerData.find(customer => customer.name === ev.target.value);
                if (!customer) {
                    return;
                }
                setSkipFetch(true);
                props.onSelect(customer);
            }}
            placeholder="type anything to show customers"
            showSuggestions
            type="Text"
            valueState="None"
            value={value}>
            {customerData.map(customer => <SuggestionItem text={customer.name} key={customer.id}/>)}
        </Input>
        {isLoading ? <span className="loader"/> : undefined}
    </div>
}
